export default __webpack_public_path__ + "static/media/video_upload_icon.733a66ba.svg";